import Http from './../http';

const prefix = '/restrict-area/integration';

export const getAll = (id) => Http.authApi().get(`${prefix}/all/${id}`);

export const get = ({ id }) => Http.authApi().get(`${prefix}/${id}`);

export const create = integrationConfig => Http.authApi().post(`${prefix}`, integrationConfig);

export const edit = integrationConfig => {
  return Http.authApi().put(`${prefix}/${integrationConfig.id}`, integrationConfig)
}

export const exclude = integrationConfig =>
  Http.authApi().delete(`${prefix}/${integrationConfig.id}/${integrationConfig.website_id}`, integrationConfig);



// WEBPACK FOOTER //
// ./src/js/services/restrictArea/integration.js